import { createContext, useContext, useState, ReactNode } from 'react';

interface LiveEditorContextType {
  liveEditor: boolean;
  setLiveEditor: (value: boolean) => void;
  editedResult: string;
  setEditedResult: (value: string) => void;
  clearEditor: () => void;
  appendToEditor: (content: string) => void;
}

interface LiveEditorProviderProps {
  children: ReactNode;
}

const LiveEditorContext = createContext<LiveEditorContextType | undefined>(undefined);

export const LiveEditorProvider: React.FC<LiveEditorProviderProps> = ({
  children,
}: LiveEditorProviderProps) => {
  const [liveEditor, setLiveEditor] = useState<boolean>(false);
  const [editedResult, setEditedResult] = useState<string>('');

  const clearEditor = () => {
    setEditedResult('');
  };

  const appendToEditor = (content: string) => {
    setEditedResult((prevContent) => {
      const trimmedContent = content.trim();
      if (!prevContent) {
        return trimmedContent + '[[LINEBREAK]]';
      }
      return `${prevContent}[[LINEBREAK]]${trimmedContent}[[LINEBREAK]]`;
    });
  };

  const value = {
    liveEditor,
    setLiveEditor,
    editedResult,
    setEditedResult,
    clearEditor,
    appendToEditor,
  };

  return <LiveEditorContext.Provider value={value}>{children}</LiveEditorContext.Provider>;
};
export const useLiveEditor = () => {
  const context = useContext(LiveEditorContext);
  if (context === undefined) {
    throw new Error('useLiveEditor must be used within a LiveEditorProvider');
  }
  return context;
};
